export default "__VITE_ASSET__DUQzu__J__"